/** 仅在当前页面内比对测试时的表单快照；不能写入 localStorage、日志或接口响应。 */
export function personalModelDraftFingerprint(draft) {
  return JSON.stringify([
    String(draft.provider || '').trim(),
    String(draft.baseUrl || '').trim().replace(/\/$/, ''),
    String(draft.model || '').trim(),
    String(draft.apiKey || '').trim(),
  ])
}

export function canSaveVerifiedDraft(draft, proof) {
  return Boolean(proof?.ticket && proof.fingerprint === personalModelDraftFingerprint(draft))
}

/** 把个人模型转换为现有模型选择弹窗可展示的条目，只传引用，不带 Key 或密文。 */
export function normalizePersonalModelForPicker(row) {
  return {
    guid: `personal:${row.modelGuid}`,
    modelRef: { source: 'personal', modelGuid: row.modelGuid },
    modelName: row.displayName,
    modelSign: row.modelSign,
    modelVendorSign: row.providerSign,
    companyName: '我的个人模型',
    modelType: 'text',
    isReasoning: 0,
    isImageRecognition: row.verifiedCapabilities?.vision === 'verified' ? 1 : 0,
    isNetwork: 0,
    usePrice: 0,
    modelDesc: '使用自己的 API Key 调用；厂商费用由 Key 持有人承担',
  }
}

/** 旧 WS 与 HMS 均只接收引用；停用/未验证模型必须在发消息前拒绝。 */
export function agentPersonalModelRef(guid, rows) {
  if (!guid) return null
  const row = (rows || []).find(item => item.modelGuid === guid)
  if (!row || row.status !== 1 || row.verifiedCapabilities?.text !== 'verified') {
    throw new Error('personal_model_unavailable')
  }
  return { source: 'personal', modelGuid: guid }
}
